import {Config} from '../config';

export const currencySymbols: Config = {
    'USD': '$', // US Dollar
    'EUR': '€', // Euro
    'SEK': 'kr', // Swedish Krona
    'CRC': '₡', // Costa Rican Colón
    'GBP': '£', // British Pound Sterling
    'ILS': '₪', // Israeli New Sheqel
    'INR': '₹', // Indian Rupee
    'JPY': '¥', // Japanese Yen
    'KRW': '₩', // South Korean Won
    'NGN': '₦', // Nigerian Naira
    'PHP': '₱', // Philippine Peso
    'PLN': 'zł', // Polish Zloty
    'PYG': '₲', // Paraguayan Guarani
    'THB': '฿', // Thai Baht
    'UAH': '₴', // Ukrainian Hryvnia
    'VND': '₫', // Vietnamese Dong
    'RUB': '₽', // Russian Ruble
    'AUD': 'AUD ', // Australian
    'CAD': 'CAD ', // Canadian,
    'NZD': 'NZD ', // New Zealand
    'CHF': 'CHF ', // New Zealand
    'HKD': 'HK$ ', // Hong Kong
    'AED': 'AED ',
    'AFN': 'AFN ',
    'ALL': 'ALL ',
    'AMD': 'AMD ',
    'ANG': 'ANG ',
    'AOA': 'AOA ',
    'ARS': 'ARS ',
    'AWG': 'AWG ',
    'AZN': 'AZN ',
    'BAM': 'BAM ',
    'BBD': 'BBD ',
    'BDT': 'BDT ',
    'BGN': 'BGN ',
    'BIF': 'BIF ',
    'BMD': 'BMD ',
    'BND': 'BND ',
    'BOB': 'BOB ',
    'BRL': 'BRL ',
    'BSD': 'BSD ',
    'BWP': 'BWP ',
    'BZD': 'BZD ',
    'CDF': 'CDF ',
    'CLP': 'CLP ',
    'CNY': 'CNY ',
    'COP': 'COP ',
    'CVE': 'CVE ',
    'CZK': 'CZK ',
    'DJF': 'DJF ',
    'DKK': 'DKK ',
    'DOP': 'DOP ',
    'DZD': 'DZD ',
    'EGP': 'EGP ',
    'ETB': 'ETB ',
    'FJD': 'FJD ',
    'FKP': 'FKP ',
    'GEL': 'GEL ',
    'GIP': 'GIP ',
    'GMD': 'GMD ',
    'GNF': 'GNF ',
    'GTQ': 'GTQ ',
    'GYD': 'GYD ',
    'HNL': 'HNL ',
    'HRK': 'HRK ',
    'HTG': 'HTG ',
    'HUF': 'HUF ',
    'IDR': 'IDR ',
    'ISK': 'ISK ',
    'JMD': 'JMD ',
    'KES': 'KES ',
    'KGS': 'KGS ',
    'KHR': 'KHR ',
    'KMF': 'KMF ',
    'KYD': 'KYD ',
    'KZT': 'KZT ',
    'LAK': 'LAK ',
    'LBP': 'LBP ',
    'LKR': 'LKR ',
    'LRD': 'LRD ',
    'LSL': 'LSL ',
    'MAD': 'MAD ',
    'MDL': 'MDL ',
    'MGA': 'MGA ',
    'MKD': 'MKD ',
    'MMK': 'MMK ',
    'MNT': 'MNT ',
    'MOP': 'MOP ',
    'MRO': 'MRO ',
    'MUR': 'MUR ',
    'MVR': 'MVR ',
    'MWK': 'MWK ',
    'MXN': 'MXN ',
    'MYR': 'MYR ',
    'MZN': 'MZN ',
    'NAD': 'NAD ',
    'NIO': 'NIO ',
    'NOK': 'NOK ',
    'NPR': 'NPR ',
    'PAB': 'PAB ',
    'PEN': 'PEN ',
    'PGK': 'PGK ',
    'PKR': 'PKR ',
    'QAR': 'QAR ',
    'RON': 'RON ',
    'RSD': 'RSD ',
    'RWF': 'RWF ',
    'SAR': 'SAR ',
    'SBD': 'SBD ',
    'SCR': 'SCR ',
    'SGD': 'SGD ',
    'SHP': 'SHP ',
    'SLL': 'SLL ',
    'SOS': 'SOS ',
    'SRD': 'SRD ',
    'STD': 'STD ',
    'SZL': 'SZL ',
    'TJS': 'TJS ',
    'TOP': 'TOP ',
    'TRY': 'TRY ',
    'TTD': 'TTD ',
    'TWD': 'TWD ',
    'TZS': 'TZS ',
    'UGX': 'UGX ',
    'UYU': 'UYU ',
    'UZS': 'UZS ',
    'VUV': 'VUV ',
    'WST': 'WST ',
    'XAF': 'XAF ',
    'XCD': 'XCD ',
    'XOF': 'XOF ',
    'XPF': 'XPF ',
    'YER': 'YER ',
    'ZAR': 'ZAR ',
    'ZMW': 'ZMW '
};
